export default __webpack_public_path__ + "26e7f9e2b3c36816904666f9b3bc5270.png";